import { useState } from 'react'
import { useNotify } from 'react-admin'
import { useNavigate } from 'react-router-dom'
import { Box, CardContent, Grid } from '@mui/material'
import { getNextLead } from '../../Utils/QuoteRequestUtils'
import SearchForm from '../../Components/Dashboard/SearchForm'
import DailyReporting from '../../Components/Dashboard/DailyReporting'
import CharityTotal from '../../Components/Dashboard/CharityTotal'
import AgentLeads from '../../Components/Dashboard/AgentLeads'
import NiceStatusButton from '../../Components/Dashboard/NiceStatusButton'
import GetLead from '../../Components/Dashboard/GetLead'
import OfferAccepted from '../../Components/Dashboard/OfferAccepted'
import HighCap from '../../Components/Dashboard/HighCap'
import LockedLeads from '../../Components/Dashboard/LockedLeads'
import Notifications from '../../Components/Dashboard/Notifications'
import InboundNotifications from '../../Components/Dashboard/InboundNotifications'
import FitnessTrackerDashboard from '../../Components/FitnessTracker/Dashboard'
import { canUseFitnessTracker } from '../../Components/FitnessTracker/Utils/utils'
import { useFitnessTrackerContext } from '../../Components/FitnessTracker/Context/FitnessTrackerContext'

export default function Dashboard() {
  const notify = useNotify()
  const navigate = useNavigate()
  const { expanded } = useFitnessTrackerContext()
  const userId = localStorage.getItem('user_id')
  const isAdmin = localStorage.getItem('permissions')?.includes('ROLE_ADMIN')
  const [disableGetLeadButton, setDisableGetLeadButton] = useState(false)
  const showFitnessTracker = canUseFitnessTracker(userId)

  const handleGetLead = async () => {
    setDisableGetLeadButton(true)

    try {
      const { status, id, message } = await getNextLead()

      if (status !== 'success' || !id) {
        notify(message ?? 'Unable to get the next lead', { type: 'error' })
        return
      }

      navigate(
        `/quote-requests/${encodeURIComponent(`/api/quote-requests/${id}`)}`
      )
    } catch (error) {
      notify('Unable to get the next lead', { type: 'error' })
    } finally {
      setDisableGetLeadButton(false)
    }
  }

  return (
    <CardContent>
      <DailyReporting />
      <Box sx={{ alignItems: 'start', display: 'flex', gap: 2, mb: 2 }}>
        <AgentLeads />
        <CharityTotal />
        <NiceStatusButton isAdmin={isAdmin} />
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: expanded ? '1fr' : '1fr 320px',
          gap: 2,
          alignItems: 'start',
        }}
      >
        <SearchForm />

        {showFitnessTracker && <FitnessTrackerDashboard />}
      </Box>

      <Grid container columnSpacing={2} rowSpacing={2} mt={2}>
        <GetLead disabled={disableGetLeadButton} onClick={handleGetLead} />
        <OfferAccepted userId={userId} />
        <HighCap userId={userId} />
        <Notifications userId={userId} />
        <InboundNotifications userId={userId} />
        <LockedLeads userId={userId} />
      </Grid>
    </CardContent>
  )
}
